<template>
  <div class="c-accordion">
    <c-accordion-section
      v-for="item in propList"
      :key="item.value"
      v-bind="item"
    />
  </div>
</template>

<script>
import CAccordionSection from '@/components/CAccordionSection'
import { props } from '@/components/CAccordion/props'
import useList from '@/uses/useList'

export default {
  name: 'CAccordion',
  components: { CAccordionSection },
  props,
  setup (props) {
    const propList = useList(props)

    return {
      propList
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
